import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var ArrowUpIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 16 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M.48 8.54a.75.75 0 0 0 1.06-.019l5.71-5.914V15.25a.75.75 0 0 0 1.5 0V2.607l5.71 5.914a.75.75 0 0 0 1.08-1.042L8.542.232a.748.748 0 0 0-1.085.001L.46 7.48a.75.75 0 0 0 .02 1.06Z"
        })
    }));
};
